module.exports = __WEBPACK_EXTERNAL_MODULE_10__;


//////////////////
// WEBPACK FOOTER
// external "oasi-widgets/dist/index.css"
// module id = 10
// module chunks = 0